import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addDays } from 'date-fns';

const ChangeProductDetails = ({ show, onClose, selectedId, refresh, name, mobile, email }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [person_name, setpersonName] = useState('');
    const [delivery_contact, setdeliverycontact] = useState('');
    const [address, setAddress] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState([]);
    const [product, setProduct] = useState('');
    const [timeline, setTline] = useState('');
    const [days, setDays] = useState(0);
    const [area, setArea] = useState(null);
    const [dp, setDp] = useState(null);

    const [startDateopt, setStartDateopt] = useState(null);
    const [endDateopt, setEndDateopt] = useState(null);

    const [timelinedata, setTlinedata] = useState(null);

    const [locationUrl, setLocationUrl] = useState('');
    const [latitude, setlatitude] = useState(null);
    const [longitude, setlongitude] = useState(null);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        const fetchleaddetails = async () => {
            try {
                const response = await axios.get(`${baseURL}/leadsubscription/${selectedId}`);
                setpersonName(response.data.data.delivery_person_name);
                setdeliverycontact(response.data.data.delivery_contact_number);
                setAddress(response.data.data.address);
                setProduct(response.data.data.product_name);
                setTline(response.data.data.timeline_name);
                setDays(response.data.data.timeline_days);
                setArea(response.data.data.area);
                setDp(response.data.data.delivery_point);
                setLocationUrl(response.data.data.location_url);
                setlatitude(response.data.data.latitude);
                setlongitude(response.data.data.longitude);


                if (response.data.data.start_date !== null && response.data.data.end_date !== null) {
                    const start = new Date(response.data.data.start_date);
                    const end = new Date(response.data.data.end_date);

                    setStartDateopt(formatDate(start));
                    setEndDateopt(formatDate(end));

                    setStartDate(response.data.data.start_date);
                    setEndDate(response.data.data.end_date);
                }

                setData(response.data.data);
                setTlinedata(response.data.data.timelinerelation);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };

        fetchleaddetails();
    }, []);


    //area
    const [areaOption, setAreaOption] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id: branch_id}});
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
                }));
                setAreaOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const fetcharea = async (id) => {
        try {
            const response = await axios.get(`${baseURL}/dropdown/dparea/${id}`);
            const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.name,
            }));
            setAreaOption(formattedsource);
            setArea(null);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // delivery point
    const [dppoption, setdpoption] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, {params: {branch_id: branch_id}});
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.delivery_point,
                }));
                setdpoption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);
    

    const handleStartDateChange = (date) => {
        setStartDateopt(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            console.log(formattedDate);
            setStartDate(formattedDate);
            if (timelinedata) {
                calculateEndDate(timelinedata, formattedDate);
            }
        } else {
            setStartDate(null);
        }
    };

    const calculateEndDate = (timeline, startDate) => {
        const all_days = timeline.all_days;
        const days_count = timeline.days;
        let sunday, monday, tuesday, wednesday, thursday, friday, saturday;
        if ( all_days === 1) {
            sunday = timeline.sunday;
            monday = timeline.monday;
            tuesday = timeline.tuesday;
            wednesday = timeline.wednesday;
            thursday = timeline.thursday;
            friday = timeline.friday;
            saturday = timeline.saturday;
        } else {
            sunday = '0';
            monday = '0';
            tuesday = '0';
            wednesday = '0';
            thursday = '0';
            friday = '0';
            saturday = '0';
        }

        // Create a days array that represents the days of the week (0 = Sunday, 6 = Saturday)
        const daysOfWeek = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
        // console.log(daysOfWeek);
    
        let currentDate = moment(startDate);
        let validDaysCount = 0;
        
        while (validDaysCount < days_count) {
            // console.log(validDaysCount, days_count);

            // Check if the current day is valid to count (if its value is 0 then count)
            const currentDayOfWeek = currentDate.day();
            
            if (daysOfWeek[currentDayOfWeek] === '0') {
                validDaysCount++;
            }
    
            // Move to the next day
            currentDate.add(1, 'days');
        }
        const endDate = currentDate.format('YYYY-MM-DD');
        setEndDate(endDate);
        setEndDateopt(currentDate.format('DD-MM-YYYY'));
    };

    const [latLng, setLatLng] = useState(null);
    

    // Extract lat/lng from pasted URL
    const extractLatLngFromUrl = (url) => {
        const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
            setlatitude(parseFloat(match[1]));
            setlongitude(parseFloat(match[2]));
            return {
                lat: parseFloat(match[1]),
                lng: parseFloat(match[2]),
            };
        }
        return null;
    };

    useEffect(() => {
        if(locationUrl) {
            const coords = extractLatLngFromUrl(locationUrl);
            if (coords) {
                setLatLng(coords);
                errors.loc = "";
            } else {
                setLatLng(null);
                errors.loc = "Not a Valid Location URL.";
            }
        }
    }, [locationUrl]);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!person_name) {
            newErrors.person_name = 'This Field is Required.';
        }

        if (!delivery_contact) {
            newErrors.delivery_contact = 'This Field is Required.';
        }

        if (!area) {
            newErrors.area = "This Field is Required.";
        }
        
        if (!dp) {
            newErrors.dp = "This Field is Required.";
        }

        if (!startDate) {
            newErrors.source = "This Field is Required.";
        }

        if (!address){
            newErrors.address = "This Field is Required.";
        }

        if(locationUrl) {
            const coords = extractLatLngFromUrl(locationUrl);
            if (!coords) {
                newErrors.loc = "Not a Valid Location URL.";
            }
        } else {
            newErrors.loc = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        
        const postData = {
            delivery_person_name: person_name,
            delivery_contact_number: delivery_contact,
            area: area,
            delivery_point: dp,
            start_date: startDate,
            end_date: endDate,
            address: address,
            updated_by: user_id,
            location_url: locationUrl,
            latitude: latitude,
            longitude: longitude
        }
        axios.put(`${baseURL}/leadsubscription/${selectedId}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Subscription Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscription Updation Failed");
            });
    };

    


    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Change Product Details</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                            <label className='text-black fs-6 font-w500'>{name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-black fs-6 font-w500'>{mobile}</label>
                        </div>
                        {/* <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                            <label className='text-black fs-6 font-w500'>{email ? email : '-'}</label>
                        </div> */}
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Product</label>
                            <label className='text-black fs-6 font-w500'>{product}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                            <label className='text-black fs-6 font-w500'>{timeline} ({days} Days)</label>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="row mt-3">
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Customer Name<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Delivery Person" 
                                    maxLength={100}
                                    value={person_name}
                                    onChange={(e) => {
                                        const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                        setpersonName(onlyAlphabets);
                                    }}
                                />
                                {errors.person_name && <div className="text-danger fs-8 mt-1">{errors.person_name}</div>}
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Mobile Number<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Mobile Number" 
                                    maxLength={10}
                                    value={delivery_contact} 
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setdeliverycontact(onlyNums);
                                    }}
                                />
                                {errors.delivery_contact && <div className="text-danger fs-8 mt-1">{errors.delivery_contact}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Start Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        minDate={addDays(new Date(), 1)} // Only allow dates from tomorrow onward
                                        value={startDateopt}
                                        format="DD-MM-YYYY"
                                        onChange={handleStartDateChange}
                                    />
                                </div>
                                {errors.source && <div className="text-danger fs-8 mt-1">{errors.source}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">End Date</label>

                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text border-0 px-0 bg-gray-200 rounded-bottom-end-0 rounded-top-end-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        value={endDateopt}
                                        format="DD-MM-YYYY"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Address<span className="required">*</span></label>
                                <textarea className="form-control" placeholder="Enter Address"
                                    maxLength={250}
                                    value={address} 
                                    onChange={(e) => setAddress(formatName(e.target.value))} 
                                />
                                {errors.address && <div className="text-danger fs-8 mt-1">{errors.address}</div>}
                            </div>
                            
                            <div className='col-lg-6 mb-4'>
                                <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                                <Select
                                    value={dppoption.find(option => option.value === dp) || null}
                                    onChange={(selectedOption) => {
                                        setDp(selectedOption.value);
                                        fetcharea(selectedOption.value);
                                    }}
                                    options={dppoption}
                                />
                                {errors.dp && <div className="text-danger fs-8 mt-1">{errors.dp}</div>}
                            </div>
                            <div className='col-lg-6 mb-4'>
                                <label className="text-black font-w500 fs-7">Area<span className="required">*</span></label>
                                <Select placeholder="Select Area"
                                    onChange={(selectedOption) => setArea(selectedOption.value)}
                                    options={areaOption}
                                    value={areaOption.find(option => option.value === area) || null}
                                />
                                {errors.area && <div className="text-danger fs-8 mt-1">{errors.area}</div>}
                            </div>
                            
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Location URL <span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Paste Google Maps location URL" value={locationUrl} onChange={(e) => setLocationUrl(e.target.value)}/>
                                {errors.loc && <div className="text-danger fs-8 mt-1">{errors.loc}</div>}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            {/* <Link className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type='submit' className="btn btn-sm btn-primary" >Update Product Details<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default ChangeProductDetails;
